import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import SuperviseActivityPanel from "@/components/supervise/supervise-activity-panel";

const SuperviseActivityPage = (): JSX.Element => <SuperviseActivityPanel />;

export const Route = createFileRoute("/_app/supervise/activity/")({
	component: SuperviseActivityPage,
});
